"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _default = exports["default"] = _styledComponents["default"].div.withConfig({
  displayName: "AttributeGrid",
  componentId: "sc-1yx00e1-0"
})(["grid-template-columns:repeat(1,1fr);grid-auto-rows:6.4rem;column-gap:1.6rem;max-width:100%;display:grid;> *{grid-column:span 1;grid-row:span 1;}@media (min-width:", "){grid-template-columns:repeat(2,1fr);row-gap:", ";}@media screen and (min-width:", "){row-gap:0;}@media (min-width:", "){gap:3.2rem;grid-template-columns:repeat(6,1fr);align-items:center;justify-content:center;grid-auto-rows:auto;> *{grid-row:span 2;grid-column:span 2;}>:nth-child(2n){margin-top:0;transform:translateY(0);}>:first-child:last-child{grid-column-start:2;grid-column-end:6;grid-row:span 3;}>:last-child:nth-child(2),>:nth-last-child(2):first-child{grid-column:span 3;grid-row:span 3;}>:last-child:nth-child(2){grid-row-start:2;grid-row-end:5;grid-column-start:4;grid-column-end:7;}>:first-child{grid-row-start:2;grid-row-end:4;grid-column-start:1;grid-column-end:3;}>:nth-child(3){grid-row-start:2;grid-row-end:4;grid-column-start:5;grid-column-end:7;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.mediaQueries.xs;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing['30_Small'];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediaQueries.s;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.mediaQueries.m;
});
//# sourceMappingURL=AttributeGrid.js.map